import { CapacityContext } from '../../hooks/useYardIssueCapacityContext'
import { YardIssueDto } from '../../models/yard-issue.model'
import { isImdgIssueType } from '../../utils/imdg-issue-presentation.util'
import { IssueCardBlockInfo } from '../atoms/IssueCardBlockInfo'
import { IssueCardCapacitySummary } from '../atoms/IssueCardCapacitySummary'
import { IssueCardContainerList } from '../atoms/IssueCardContainerList'
import { IssueCardImdgDetails } from '../atoms/IssueCardImdgDetails'
import { IssueCardPositions } from '../atoms/IssueCardPositions'
import { IssueCardRuleInfo } from '../atoms/IssueCardRuleInfo'

interface Props {
  issue: YardIssueDto
  capacityContext: CapacityContext | null
}

export const IssueCardBody = ({ issue, capacityContext }: Props) => {
  if (capacityContext) {
    return (
      <>
        {capacityContext.kind === 'rule' && (
          <IssueCardRuleInfo name={capacityContext.name} ruleType={capacityContext.ruleType} />
        )}
        {capacityContext.kind === 'block' && <IssueCardBlockInfo name={capacityContext.name} />}
        <IssueCardCapacitySummary
          utilizationPct={capacityContext.capacity.utilizationPct}
          consumedTeu={capacityContext.capacity.consumedTeu}
          totalTeu={capacityContext.capacity.totalTeu}
        />
      </>
    )
  }

  return (
    <>
      <IssueCardContainerList
        containerNumbers={issue.containerNumbers}
        containerIds={issue.containerIds}
      />
      {isImdgIssueType(issue.issueType) && <IssueCardImdgDetails issue={issue} />}
      {issue.positions.length > 0 && (
        <IssueCardPositions serializedPositions={issue.serializedPositions} />
      )}
    </>
  )
}
